module.exports = __webpack_public_path__ + "static/media/Arial-BoldMT.ac85e03d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arial-BoldMT.ttf
// module id = 12
// module chunks = 0